import React, { useEffect, useLayoutEffect } from "react";
import { useNavigate } from "react-router-dom";
// import commingSoonHTML from './comming-soon.html'

const AdminRedirect = () => {
  useLayoutEffect(() => {
    window.location.href = import.meta.env.VITE_API_URL + "/admin/";
  }, [])
};

export default AdminRedirect;
